import { makeStyles } from "@material-ui/core/styles";
import { APP_BAR_HEIGHT } from "../../utils/constants/index";
const styles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    height: APP_BAR_HEIGHT,
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.contrastText
  },
  brand: {
    flexGrow: 1,
    paddingLeft: theme.spacing(1),
  },
  navLink: {
    padding: "22px"
  },
  link: {
    cursor: "pointer"
  },
  signUpBtn: {
    marginLeft: theme.spacing(1),
  }
}));
export default styles;